import Page from "webPage/Page";
import StickySection from "util/StickySection";
import {handleScrollingSection} from "util/scrolling-section";
import $ from "jquery";
import handleOnPageNavigationBlocks from "../util/handleOnPageNavigationBlock";
import ComparisonTable from "../util/ComparisonTable";
import {handleMoreInfoLinks} from "../util/handleMoreInfoLinks";
import handleStickyComparisonTable from "../util/handleStickyComparisonTable";

/* THE SPACE AFTER page-template-technologies-inner IS INTENTIONAL DO NOT DELETE. */
Page.register([
    "page-template-technologies-inner ",
    "page-template-technologies-inner-anka",
    "page-template-technologies-inner-gravitee",
    "page-template-technologies-inner-azure",
    "page-template-red-hat-technology-inner",
    "page-template-boomi-technology-inner",
    "page-template-boomi-technology-pricing",
    "page-template-boomi-technology--salesforce-integration",
    "page-template-azure-technology-inner",
    "page-template-azure-technology-pricing",
], () => {
    if ($(".js-sticky-section").length > 0) {
        new StickySection($(".js-sticky-section"), 1200, "50px");
    }
    if ($(".js-sticky-title").length > 0) {
        new StickySection($(".js-sticky-title"), 1200, "50px");
    }
    if ($(".js-sticky-comparison-table-header").length > 0) {
        new StickySection($(".js-sticky-comparison-table-header"));
    }

    $("body").on("click", ".js-dropdown-btn", function () {
        $(this)
            .parents(".dropdown")
            .toggleClass("dropdown--active")
            .find(".dropdown__body")
            .stop()
            .slideToggle();
    }).on("click", '.js-region-select', function () {
        let $this = $(this);
        let country = $this.attr('data-country');

        $('.js-pricing-view').removeClass('pricing-view--active');
        $('.js-region-select').removeClass('pricing-region-selector__button--active');

        $this.addClass('pricing-region-selector__button--active')
        $('.js-pricing-view[data-country="' + country +'"]').addClass('pricing-view--active');

        return false;
    });

    handleScrollingSection($('.js-scrolling-logos'));
    handleScrollingSection($('.js-scrolling-logos-left'), "left");
    if ($(".js-tabs-nav-slider")) {
        handleOnPageNavigationBlocks();
    }

    let $comparisonTable = $('.js-comparison-table');

    if ($comparisonTable.length > 0) {
        new ComparisonTable($comparisonTable);
        handleStickyComparisonTable();
    }

    if ($(".js-more-info-popup").length > 0) {
        handleMoreInfoLinks()
    }
});
